import './Heading.scss'
const MainHeading = ({title, alignCenter }) => {
    return (
        <div className={`main-heading ${alignCenter ? 'text-center' : 'text-center lg:text-start'} my-7`}>
            <h1>{title}</h1>
        </div>
    )
}
export default MainHeading